import { Box, Container, Flex, Heading, Image, Text } from '@chakra-ui/react';
import { Seo } from '../components/Seo';
import { PageHeader } from '../components/PageHeader';
import { Section, Reveal } from '../components/Section';
import { CtaBanner } from '../components/CtaBanner';
import { Disclaimer } from '../components/Disclaimer';
import { approachSteps, images } from '../data/site';
export function Approach() {
  return <>
      <Seo title="Our Approach | Futuramy Investment LLC" description="Thoughtful decisions, sustainable opportunities and a long-term perspective guide how Futuramy Investment LLC identifies, evaluates and develops business opportunities." path="/approach" data-id="element-179" data-mp="15t0v02vo6ho4" />
      <PageHeader eyebrow="Approach" title="Our Approach" subtitle="Thoughtful decisions. Sustainable opportunities. Long-term perspective." data-id="element-180" data-mp="19tazfb3td00v" />

      <Box bg="navy.50" borderBottom="1px solid" borderColor="navy.100" data-id="element-181" data-mp="i2d8ocl0bpi1">
        <Container maxW="1200px" px={{
        base: 6,
        md: 8
      }} py={{
        base: 12,
        md: 16
      }} data-id="element-182" data-mp="i0am62j2cei2">
          <Image src={images.approach} alt="Abstract illustration of four evenly spaced forms connected by a single line, representing a step-by-step process" w="100%" h={{
          base: '200px',
          md: '300px'
        }} objectFit="cover" border="1px solid" borderColor="navy.100" loading="lazy" data-id="element-183" data-mp="3ia57envfb702" />
        </Container>
      </Box>

      <Section data-id="element-184" data-mp="2zdx43plz167e">
        <Box borderTop="1px solid" borderColor="navy.200" data-id="element-185" data-mp="34ax9rzews6xz">
          {approachSteps.map((step, index) => <Reveal key={step.number} delay={index * 0.06} data-id="element-186" data-mp="39a9ry6uu4pu8" data-mpi={index}>
              <Flex direction={{
            base: 'column',
            md: 'row'
          }} gap={{
            base: 4,
            md: 16
          }} py={{
            base: 10,
            md: 14
          }} borderBottom="1px solid" borderColor="navy.100" align="flex-start" data-id="element-187" data-mp="398ozcms2zgz0">
                <Text fontSize={{
              base: '3xl',
              md: '5xl'
            }} fontWeight={600} color="navy.200" lineHeight={1} minW={{
              md: '160px'
            }} data-id="element-188" data-mp="th14cwwmnyiu">
                  {step.number}
                </Text>
                <Box maxW="760px" data-id="element-189" data-mp="2ym5f5bi85uyz">
                  <Heading as="h2" fontSize={{
                base: 'xl',
                md: '2xl'
              }} mb={4} data-id="element-190" data-mp="2ul3lrbazod4x">
                    {step.title}
                  </Heading>
                  <Text fontSize={{
                base: 'md',
                md: 'lg'
              }} color="navy.500" fontWeight={300} lineHeight={1.8} data-id="element-191" data-mp="26wkdgvrxw0cu">
                    {step.detailed}
                  </Text>
                </Box>
              </Flex>
            </Reveal>)}
        </Box>
      </Section>

      <Disclaimer data-id="element-192" data-mp="2awkt2jqryhlh" />
      <CtaBanner data-id="element-193" data-mp="2aw1jprf6x1j2" />
    </>;
}